import {useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from '@heroicons/react/solid'
export default function SingleplayerSetup(props) {

    const {timeLimit, scoreLimit, checkWordList, autoFillFirstLetter} = props.gameSettings
    const {onGameSettingChange} = props
  
const navigate = useNavigate()

    
    return (
        <>
            <div className="p-3 bg-gray-50 justify-center content-center">
                <ChevronLeftIcon onClick={() => navigate('/')} className="text-black h-6 w-6 cursor-pointer" />
                <h3 className="text-center text-xl">Game settings</h3>
                <hr className="my-3" />
                <p className="mb-3">TIME LIMIT</p>

                <div className="inline-flex rounded-md shadow-sm mb-3" role="group">

                <button onClick={() => onGameSettingChange({timeLimit: 5})} type="button" className={`${timeLimit === 5 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        5s
                 </button>



                <button onClick={() => onGameSettingChange({timeLimit: 10})} type="button" className={`${timeLimit === 10 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        10s
                 </button>



                  <button onClick={() => onGameSettingChange({timeLimit: 15})} type="button" className={`${timeLimit === 15 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        15s
                    </button>

                    <button onClick={() => onGameSettingChange({timeLimit: 30})} type="button" className={`${timeLimit === 30 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        30s
                    </button>

                    <button onClick={() => onGameSettingChange({timeLimit: 45})} type="button" className={`${timeLimit === 45 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        45s
                    </button>

                    <button onClick={() => onGameSettingChange({timeLimit: 60})} type="button" className={`${timeLimit === 60 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        60s
                    </button>

                    <button onClick={() => onGameSettingChange({timeLimit: 90})} type="button" className={`${timeLimit === 90 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        90s
                    </button>

                    <button onClick={() => onGameSettingChange({timeLimit: 0})} type="button" className={`${timeLimit === 0 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        ZEN MODE
                    </button>

                </div>

                
                <p className="mb-3">SCORE LIMIT</p>
                <div className="inline-flex rounded-md shadow-sm mb-3" role="group">


                    <button onClick={() => onGameSettingChange({scoreLimit: 50})} type="button" className={`${scoreLimit === 50 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        50
                    </button>

                    <button onClick={() => onGameSettingChange({scoreLimit: 100})} type="button" className={`${scoreLimit === 100 ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                       100
                    </button>


                </div>

                <p className="mb-3">WORD LIST</p>
                <div className="inline-flex rounded-md shadow-sm mb-3" role="group">


                    <button onClick={() => onGameSettingChange({checkWordList: true})} type="button" className={`${checkWordList === true ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        ON
                    </button>

                    <button onClick={() => onGameSettingChange({checkWordList: false})} type="button" className={`${checkWordList === false ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                       OFF
                    </button>


                </div>

                <p className="mb-3">AUTOFILL FIRST LETTER</p>
                <div className="inline-flex rounded-md shadow-sm mb-3" role="group">


                    <button onClick={() => onGameSettingChange({autoFillFirstLetter: true})} type="button" className={`${autoFillFirstLetter === true ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                        ON
                    </button>

                    <button onClick={() => onGameSettingChange({autoFillFirstLetter: false})} type="button" className={`${autoFillFirstLetter === false ? 'hover:bg-gray-100 text-orange-500' : 'bg-white text-gray-900'} py-2 px-4 text-sm font-medium   border-gray-200 hover:bg-gray-100 hover:text-orange-500 focus:z-10 focus:ring-2 focus:ring-orange-500 focus:text-black dark:bg-gray-700 dark:border-gray-600 dark:text-black dark:hover:text-black dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-black`}>
                       OFF
                    </button>


                </div>


                <p className="mb-3">PLAYERS</p>

                <div className="container mb-5">
                    <div className="bg-white p-2 relative mb-2">
                        <div className="bg-lime-500" style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, width: "10px" }}></div>
                        <p className="ml-5"> You</p>
                    </div>
                    <div className="bg-white p-2 relative">
                        <div className="bg-sky-500" style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, width: "10px" }}></div>
                        <p className="ml-5"> PC</p>
                    </div>
                </div>


                <div className="flex justify-center content-center">
                    <button onClick={() => navigate("/singleplayer/gameplay")} type="button" className="w-32 text-white bg-orange-400 dark:bg-orange-500  font-medium rounded-lg text-sm px-5 py-2.5 text-center">Start Game</button>
                </div>


            </div>
        </>
    )

}